import SwitchButton from "@components/ui/SwitchButton";
import { camelToTitle } from "@utils/string-helpers";

const ArrayItemSwitchButton = (props) => {
  return (
    <div className="bg-white my-2 rounded-md">
      <SwitchButton
        label={camelToTitle(props.name)}
        inputValue={props.value}
        checked={props.value}
        onClickCallback={() => {
          props.onChange(!props.value);
        }}
        labelStyle="w-max"
      />
    </div>
  );
};
export default ArrayItemSwitchButton;
